export class DepartmentInfoTab {
    departmentID:number;
    disabled:boolean;
    removable:boolean;
    title:string;
    active:boolean;
    operatingCountryId:number;
  }


// WEBPACK FOOTER //
// ./src/app/customerservice/models/department-info-tab-model.ts